import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

export interface FinalizeUnstakeViewProps {
  actionsViewState: ActionsViewState
  spk: Token
  unstakeAmount: NormalizedNumber
}

export function FinalizeUnstakeView({ actionsViewState, spk, unstakeAmount }: FinalizeUnstakeViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Finalize SPK unstake</DialogTitle>

      <FormAndOverviewWrapper>
        <TransactionOverview>
          <TransactionOverview.Row>
            <TransactionOverview.Label>Outcome</TransactionOverview.Label>
            <TransactionOverview.TokenAmount
              token={spk}
              amount={unstakeAmount}
              showUsdAmount="when-positive"
              amountDataTestId={testIds.spkStaking.finalizeUnstakeDialog.transactionOverview.amount}
              usdAmountDataTestId={testIds.spkStaking.finalizeUnstakeDialog.transactionOverview.amountUSD}
            />
          </TransactionOverview.Row>
        </TransactionOverview>
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
